import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './ProductFooter.css';

const ProductFooter = props => (
  <footer className={styles.plp}>
    <div className={styles.container}>
      <div className={styles.aligned}>
        <ul className={styles.links}>
          {props.renderMainLinks(styles, 'plp')}
        </ul>
      </div>
      <div className={styles.aligned}>
        <ul className={styles.socials}>
          {props.renderSocialLinks(styles)}
        </ul>
        <p className={classnames('tag', styles.information)}>
          {props.copyright}
        </p>
      </div>
    </div>
  </footer>
);

ProductFooter.propTypes = {
  copyright: PropTypes.string,
  renderMainLinks: PropTypes.func,
  renderSocialLinks: PropTypes.func
};

ProductFooter.defaultProps = {
  copyright: `Airtel India \u00A9 ${(new Date()).getFullYear()} –– All Rights Reserved.`,
};

ProductFooter.displayName = 'ProductFooter';

export default ProductFooter;



// WEBPACK FOOTER //
// ./src/uis/components/Footer/ProductFooter/ProductFooter.js